import useCMSList from "./useCMSList";

export const cmsTypes = [
  "COLORS",
  "ICONS",
  "LOGOS",
  "BACKGROUNDS",
  "VARIABLES",
  "MASKINGS",
  "COMPONENTS",
  "NAVIGATION_ICONS",
  "CONTENTS"
] as const;

export type CMSType = (typeof cmsTypes)[number];

const useCMS = (type?: CMSType) => {
  const { data } = useCMSList();

  const getCMSByType = (type: CMSType) => {
    if (!data?.data?.data) return null;

    const parsedBody = data?.data?.data
      ?.map((item) => {
        try {
          return { ...item.attributes, body: JSON.parse(item.attributes.body) };
        } catch {
          return item.attributes;
        }
      })
      ?.find((item) => item.type === type)?.body;

    if (!parsedBody) return null;
    return parsedBody;
  };

  return { data, cmsData: getCMSByType(type), getCMSByType };
};

export default useCMS;
